// extracted by mini-css-extract-plugin
export var body = "_hq-0";
export var sectionHeader = "_hq-4";
export var shortcutColumns = "_hq-2";
export var shortcutList = "_hq-1";
export var shortcutSection = "_hq-3";